import { render, staticRenderFns } from "./ConventionTeaserContent.vue?vue&type=template&id=578a8dde&scoped=true"
import script from "./ConventionTeaserContent.vue?vue&type=script&lang=js"
export * from "./ConventionTeaserContent.vue?vue&type=script&lang=js"
import style0 from "./ConventionTeaserContent.vue?vue&type=style&index=0&id=578a8dde&prod&scoped=true&lang=sass"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "578a8dde",
  null
  
)

export default component.exports